import React, { useState, useEffect } from 'react'
import "./Login.css";
import { Link, useHistory } from "react-router-dom";
import { auth } from './firebase';
import Skblack from './Skblack.jpeg'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import Tooltip from "@mui/material/Tooltip";
import PhoneIcon from '@mui/icons-material/Phone'
import swal from 'sweetalert';

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const [passType, setPassType] = useState('')
    useEffect(() => {
        if (showPass) {
            setPassType('text')
        }
        else {
            setPassType('password')
        }
    }, [showPass])
    const login = (event) => {
        event.preventDefault();
        auth
            .signInWithEmailAndPassword(email, password)
            .then((auth) => {
                const cart=JSON.parse(localStorage.getItem(`cart.null`))
                const ucart=JSON.parse(localStorage.getItem(`cart.${email}`))
                if(ucart!=null){
                    localStorage.setItem(`cart.${email}`,JSON.stringify([...cart,...ucart]))
                }
                else{
                    localStorage.setItem(`cart.${email}`,JSON.stringify([...cart]))
                }
                localStorage.setItem(`cart.null`,JSON.stringify([]))
                swal("Logged In Successfully","","success")
                history.push('/');
            })
            .catch(e => swal("",`${e.message}`,"error"));
    };
    const register = (event) => {
        event.preventDefault();
        auth
            .createUserWithEmailAndPassword(email, password)
            .then(auth => {
                history.push('/');
            })
            .catch((e) => alert(e.message));
    };
    return (
        <div className="login">
            <Link to="/">
                {/* "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png" */}
                <img className="login__logo" src={Skblack} />
            </Link>
            <div className="login__container">
                <form>
                    <h2>Sign-In</h2>

                    {/* <h5><EmailIcon /></h5> */}
                    <p className='inputWithIcon'>
                    <input value={email} placeholder='Enter your email...' onChange={event => setEmail(event.target.value)} type="email" />
                    <i className='email__icon'><EmailIcon /></i>
                    </p>
                   
                    {/* <h5><LockIcon /></h5> */}
                    <p className='inputWithIcon'>
                    <input className='register__email' placeholder='Enter password here...' type={passType} onChange={event => setPassword(event.target.value)}
                        value={password} id='pwd'
                    />
                    <i className='lock__icon'><LockIcon /></i>
                        <i className='visible__icon'>{showPass ?
                            <Tooltip title='Hide password'>
                                <VisibilityOffIcon style={{ 'color': 'red' }} className='ml-1' onClick={() => setShowPass(v => !v)} />
                            </Tooltip>
                            :
                            <Tooltip title='Show password'>
                                <VisibilityIcon className='ml-1' style={{ 'color': 'green' }}
                                    onClick={() => setShowPass(v => !v)} />
                            </Tooltip>
                        }
                        </i>
                    </p>
                    <button onClick={login} type="submit" className="login__signInButton"> Sign-in</button>
                </form>
                <center><p className='mt-2 '>
                    <Link to="/ForgotPassword" >
                        Forgot Password?
                </Link>
                </p></center>
                <p className='text-center mt-0 font-weight-bold or'>Or</p>
                <Link to='/phone'> <p className='text-center mt-0 '><span className='text-dark mr-2'><PhoneIcon style={{'color':'#aaa'}}/></span>Login with Mobile No.</p></Link>
                
                {/* <p>By signing-in you are agree to SK's Grocery Condition of Use & Sale. Please our Privacy Notice,our Cookie Notice and our interest-Based Ads Notice</p> */}
                {/* <p>Don't have account? <span><Link to='/regiser' >Sign up</Link> <span></p>
                 */}
                 <center>
                 <p>New to SK Grocery? <span><Link to='/register'>Register</Link></span></p>
                 </center>
                 
                {/* <button onClick={register} className="login__registerButton">Create Your SK's account</button> */}
            </div>
        </div>
    )
}

export default Login
